import React from 'react'

import {actionSchema} from '../../services/EntityRowActionsSchema'
import {people_get_addresses} from '../../services/BE'

import DashboardCard from '../../@react-fefmwk/cards/modules/DashboardCard'
import Table from '../../@react-fefmwk/tables/modules/Table'
import AdapterLink from '../../@react-fefmwk/links/modules/AdapterLink'

import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import ErrorIcon from '@material-ui/icons/Error'
import LocationOnIcon from '@material-ui/icons/LocationOn'

class WidgetPersonAddresses extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            addresses: [],
        }
    }
    
    async updateAddresses() {
        const id_people = this.props.id_people
        if( id_people )
            this.setState({
                addresses: await people_get_addresses(id_people),
            })
    }

    async componentDidMount() {
        this.updateAddresses()
    }
    
    async componentDidUpdate(prevProps) {
        const id_people = this.props.id_people
        if( id_people !== prevProps.id_people )
            this.updateAddresses()
    }

    render() {
        const id_people = this.props.id_people
        const addresses = this.state.addresses

        const dashboardcardActions = this.props.hasOwnProperty('dashboardcardActions')
            ? this.props.dashboardcardActions
            : true
        const dashboardcardTitle = this.props.dashboardcardTitle
                ? this.props.dashboardcardTitle
                : "Addresses"

        let addressesRowActions = actionSchema('addresses')
        if( addressesRowActions.length ) {
            addressesRowActions.map((act) => {
                if( act.hasOwnProperty('action') && act.action === 'edit' && act.hasOwnProperty('link') ) {
                    act.link += '?id_people'
                }
            })
        }

        const cardProps = {}
        cardProps['Content'] = addresses.length
            ? <Table material dense
                hideHeaders
                defaultPageSize="100"
                data={addresses}
                rowActions={addressesRowActions}
                rowActionsField="id_address"
            />
            : <Chip icon={<ErrorIcon />} label="Nessun indirizzo trovato" variant="outlined" />

        if( dashboardcardActions )
            cardProps['TopActions'] = <Button
                variant="text" color="primary" size="small"
                startIcon={<LocationOnIcon fontSize="small" />}
                component={AdapterLink}
                to={"/addresses/add?id_people="+id_people}
            >Nuovo</Button>

        return <DashboardCard title={dashboardcardTitle} {...cardProps} />
    }
}

export default WidgetPersonAddresses